<p-menubar appendTo="body" baseZIndex="1000" [model]="items" [autoDisplay]="false" [style]="{'font-size':'0.9rem'}">
  <button
    #btn
    type="button"
    pButton
    icon="pi pi-user"
    class="p-button-rounded button-user"
    (click)="menu.toggle($event)"
  > </button>
  <p-slideMenu
    #menu
    [model]="userMenu"
    [popup]="true"
    [viewportHeight]="250"
    appendTo="body"
    [baseZIndex]="1000"
  ></p-slideMenu>
</p-menubar>

<p-confirmDialog appendTo="body"></p-confirmDialog>

<p-dialog
  header="Conexiones activas"
  [(visible)]="sessionDialogVisible"
  [modal]="true"
  [style]="{ width: 'min(900px, 96vw)' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
>
  <div class="session-dialog-header">
    <p class="session-dialog-copy">Revisa las conexiones activas del sistema y cierra las que no deban seguir abiertas.</p>
    <button pButton type="button" icon="pi pi-refresh" class="p-button-text" label="Recargar" (click)="loadRefreshSessions()"></button>
  </div>

  <p-table [value]="refreshSessions" [loading]="loadingRefreshSessions" responsiveLayout="scroll" styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th>Usuario</th>
        <th>Dispositivo</th>
        <th>IP</th>
        <th>Creada</th>
        <th>Ultimo uso</th>
        <th>Expira</th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-session>
      <tr>
        <td>
          <div class="session-device">{{ session.userName || 'Usuario sin nombre' }}</div>
          <div class="session-user-agent">{{ session.userEmail || '-' }}</div>
        </td>
        <td>
          <div class="session-device">{{ session.device }}</div>
          <div class="session-user-agent">{{ session.userAgent || 'Sin informacion adicional' }}</div>
          <div class="session-current" *ngIf="session.current">Sesion actual</div>
        </td>
        <td>{{ session.ipAddress || '-' }}</td>
        <td>{{ session.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ session.lastUsedAt ? (session.lastUsedAt | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
        <td>{{ session.expiresAt | date:'dd/MM/yyyy HH:mm' }}</td>
        <td class="session-actions-cell">
          <button
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-sm p-button-danger p-button-text"
            [label]="session.current ? 'Cerrar esta sesion' : 'Revocar'"
            [disabled]="revokingSessionId === session.id"
            (click)="revokeSession(session)"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">No hay conexiones activas registradas.</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<p-dialog
  header="Dispositivos con notificaciones"
  [(visible)]="pushSubscriptionsDialogVisible"
  [modal]="true"
  [style]="{ width: 'min(900px, 96vw)' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
>
  <div class="session-dialog-header">
    <p class="session-dialog-copy">Revisa los dispositivos que tienen suscripcion push activa y elimina los que ya no deban recibir avisos.</p>
    <button pButton type="button" icon="pi pi-refresh" class="p-button-text" label="Recargar" (click)="loadPushSubscriptions()"></button>
  </div>

  <p-table [value]="pushSubscriptions" [loading]="loadingPushSubscriptions" responsiveLayout="scroll" styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th>Dispositivo</th>
        <th>IP</th>
        <th>Creada</th>
        <th>Ultima actualizacion</th>
        <th>Endpoint</th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-subscription>
      <tr>
        <td>
          <div class="session-device">{{ subscription.device }}</div>
          <div class="session-user-agent">{{ subscription.userAgent || 'Sin informacion adicional' }}</div>
        </td>
        <td>{{ subscription.ipAddress || '-' }}</td>
        <td>{{ subscription.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ subscription.updatedAt | date:'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <div class="push-endpoint">{{ subscription.endpoint }}</div>
        </td>
        <td class="session-actions-cell">
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-sm p-button-danger p-button-text"
            label="Eliminar"
            [disabled]="removingPushSubscriptionId === subscription.id"
            (click)="removePushSubscription(subscription)"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">No hay dispositivos push registrados para este usuario.</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

